<template>
  <div class="haulage-revenue-drill-through-main">
    <!-- Top bar showing filter selections -->
    <div class="filtered-section" id="filtered-section">
    <div class="filtered-items">
      <div class="filtered-row">
        <div class="filter-title-long">Ready for Billing Date</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{ this.fromDate }} to {{ this.toDate }}</div>
      </div>
      <div class="filtered-row">
        <div class="filter-title-long">Customer</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{ this.selectedCustomerInfo }}</div>
      </div>
    </div>
    <div class="filtered-items">
      <div class="filtered-row">
        <div class="filter-title">Job Type</div>
        <div class="colon-separator">:</div>
        <div class="filter-details"> {{ this.selectedJobTypeInfo }}</div>
      </div>
      <div class="filtered-row">
        <div class="filter-title">Tariff Area</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{ this.selectedAreaInfo }}</div>
      </div>
    </div>
    <div class="refresh-section">
      <div v-if="!loading">Last Refreshed : {{ this.refreshDate }}</div>
    </div>
  </div>
    <div class="drill-through-body" id="drill-through-body">
      <TableBox :title="tableTitle" :tableData="drillThroughDetails" :dataType="columnType"/>
    </div>
    <Loader :loadingText="loadText" :isVisible.sync="loading" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      loadText: 'Getting details',
      fromDate: '',
      toDate: '',
      getCustomerCode: '',
      getJobType: '',
      getAreaCode: '',
      selectedCustomerInfo: '',
      selectedJobTypeInfo: '',
      selectedAreaInfo: '',
      refreshDate: '',
      drillThroughDetails: [],
      tableTitle: '',
      columnType: {}
    }
  },
  props: {
  },
  methods: {
    // Get items from session storage
    getAllFromStorage: async function() {
      var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
      this.fromDate = details.fromDate;
      this.toDate = details.toDate;
      this.getCustomerCode = details.getCustomerCode;
      this.getJobType = details.getJobType;
      this.getAreaCode = details.getAreaCode;
      this.selectedJobTypeInfo = details.selectedJobTypeInfo;
      this.selectedCustomerInfo = details.selectedCustomerInfo;
      this.selectedAreaInfo = details.selectedAreaInfo;
      this.refreshDate = details.lastRefresh;
      this.tableTitle = details.title;
    },
    // Format currency (digit grouping & decimal)
    // Data and an array of key/column to format 
    // currencyFormat: function(getDrillThroughData, currencyColumnKey) {
    //   for (var i in currencyColumnKey) {
    //     for (var x in getDrillThroughData){
    //       // Check if the key is present in the data
    //       if (getDrillThroughData[x].hasOwnProperty(currencyColumnKey[i])){
    //         // Format data only when it is not null (prevent TypeError cannot read null)
    //         if (getDrillThroughData[x][currencyColumnKey[i]] != null) {
    //         getDrillThroughData[x][currencyColumnKey[i]] = getDrillThroughData[x][currencyColumnKey[i]].toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    //         }
    //       }
    //     }
    //   }
    // },
    
    // Format currency (digit grouping, decimal symbol and decimal)
    // Parse in data and an array of key/column to format 
    currencyFormat: function(getDrillThroughData, currencyColumnKey) {
      for (var i in currencyColumnKey) {
        for (var x in getDrillThroughData){
          // Check if the key is present in the data
          if (getDrillThroughData[x].hasOwnProperty(currencyColumnKey[i])){
            // Format the data using function declared as Vue prototype currencyFormat
            getDrillThroughData[x][currencyColumnKey[i]] = this.$currencyFormat(getDrillThroughData[x][currencyColumnKey[i]]);
          }
        }
      }
    },
    // Generate drill through table  
    drillThroughGenerate: async function() {
      if (this.tableTitle.includes('Revenue by Prime Mover Details')) {
      //   this.drillThroughDetails = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS_PM&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
      // }
      // else if (this.tableTitle.includes('Consignment Details')) {
      //   this.drillThroughDetails = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS_CN&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
      // }
      // else if (this.tableTitle.includes('Revenue by Driver Details')) {
      //   this.drillThroughDetails = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS_DRIVER&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        var drillThrough = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS_PM&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        var getDrillThroughData = drillThrough;
        // Columns data type
        this.columnType = {
          '#' : 'number',
          'Haulage' : 'number',
          'Rebate' : 'number',
          'Haulage after Rebate' : 'number',
          'Toll' : 'number',
          'FAF' : 'number',
          'DGC' : 'number',
          'Others' : 'number',
          'Total' : 'number',
          'Total Billed' : 'number',
          '20Ft' : 'number',
          '40Ft' : 'number',
          'TEUs' : 'number',
          'Cont' : 'number',
          'Own Cont' : 'number',
          'Outsource Cont' : 'number',
          'Own Total' : 'number',
          'Outsourced Total' : 'number'
        }
        // Key/Column to format 
        var currencyColumnKey = ["Haulage", "Rebate", "Haulage after Rebate", "Toll", "FAF", "DGC", "Others", "Total", "Total Billed", "Own Total", "Outsourced Total"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      else if (this.tableTitle.includes('Consignment Details')) {
        var drillThrough = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS_CN&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        var getDrillThroughData = drillThrough;
        // Columns data type
        this.columnType = {
          'Date' : 'date',
          'Haulage' : 'number',
          'Rebate' : 'number',
          'Haulage after Rebate' : 'number',
          'Toll' : 'number',
          'FAF' : 'number',
          'DGC' : 'number',
          'Others' : 'number',
          'Total' : 'number',
        }
         // Key/Column to format 
        var currencyColumnKey = ["Haulage", "Rebate", "Haulage after Rebate", "Toll", "FAF", "DGC", "Others", "Total"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      else if (this.tableTitle.includes('Revenue by Driver Details')) {
        var drillThrough = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS_DRIVER&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        var getDrillThroughData = drillThrough;
        // Columns data type
        this.columnType = {
          '#' : 'number',
          'Haulage' : 'number',
          'Rebate' : 'number',
          'Haulage after Rebate' : 'number',
          'Toll' : 'number',
          'FAF' : 'number',
          'DGC' : 'number',
          'Others' : 'number',
          'Total' : 'number',
          'Total Billed' : 'number',
          '20Ft' : 'number',
          '40Ft' : 'number',
          'TEUs' : 'number',
          'Cont' : 'number',
          'Own Cont' : 'number',
          'Outsource Cont' : 'number',
          'Own Total' : 'number',
          'Outsourced Total' : 'number'
        }
        // Key/Column to format 
        var currencyColumnKey = ["Haulage", "Rebate", "Haulage after Rebate", "Toll", "FAF", "DGC", "Others", "Total", "Total Billed", "Own Total", "Outsourced Total"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      this.loading = false;
    }
  },
  async mounted() {
    this.loading = true;
    // Get items from session storage
    this.getAllFromStorage();

    // Set tablebox height dynamically
    var setTabulatorHeight = 'calc(' + '100%' + ' - ' + $("#filtered-section").height() + 'px';
    $("#drill-through-body").css('height', setTabulatorHeight);

    // Generate drill through table 
    this.drillThroughGenerate(); 
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.haulage-revenue-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;
  display: flex;
  flex-direction: column; 

  > .drill-through-body {
    background-color: white;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
  > .filtered-section {
      width: 100%;  
      height: auto;
      background-color: white;
      border-radius: 5px;
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 3px;
    > .filtered-items {
      width: calc(100% - 250px);
      > .filtered-row {
        display: flex;
        align-items: center;
        > .filter-title-long {
            width: 270px;
            padding-left:3px;
        }
        > .filter-title {
          width: 120px;
          padding-left:3px;
        }
        > .colon-separator {
          margin: 0 5px;
        }
        > .filter-details {
          width: 100%;
        }
      }
    }
    
    > .refresh-section {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      margin-right: 3px;
    }
  }
}
</style>